import { configure } from 'vee-validate'

configure({
  validateOnBlur: false
})

export default defineNuxtPlugin(nuxtApp => {})
